import {Image, View} from "react-native";
import {TouchableOpacity} from "react-native-gesture-handler";
import {FontAwesome, MaterialIcons} from "@expo/vector-icons";
import * as React from "react";
import {SectionTitle} from "./section-title";

export function ContactUs(props) {
    return <>
        <SectionTitle>Contact us</SectionTitle>
        <View style={{
            flexDirection: "row",
            margin: 20,
            marginBottom: 20,
            marginTop: 10,
            borderRadius: 10,
            backgroundColor: "rgba(0,0,0,0)",
            alignItems: 'center',
            justifyContent: 'space-between'
        }}>
            <View>
                <TouchableOpacity style={{alignItems: "center"}} onPress={props.onPressPhone}>
                    <Image source={require('../../../../assets/images/home/icon-contact-phone.png')} />
                </TouchableOpacity>
            </View>
            <View>
                <TouchableOpacity style={{alignItems: "center"}}
                                  onPress={props.onPressEmail}>
                    <Image source={require('../../../../assets/images/home/icon-contact-mail.png')} />
                </TouchableOpacity>
            </View>
            <View>
                <TouchableOpacity style={{alignItems: "center"}}
                                  onPress={props.onPressFB}>
                    <Image source={require('../../../../assets/images/home/icon-contact-fb.png')} />
                </TouchableOpacity>
            </View>
            <View>
                <TouchableOpacity style={{alignItems: "center"}}
                                  onPress={props.onPressInstagram}>
                    <Image source={require('../../../../assets/images/home/icon-contact-instagram.png')} />
                </TouchableOpacity>
            </View>
        </View>
    </>;
}